export interface MetricsSeries {
  name: string
  data: number[]
}

export enum SpendMetricsAggregates {
  Average = 'AVERAGE',
  Count = 'COUNT',
  Sum = 'SUM',
}

export enum SpendMetricsPeriods {
  Day = 'DAY',
  Week = 'WEEK',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Year = 'YEAR',
}

export enum SpendMetricsTypes {
  Currency = 'CURRENCY',
  Long = 'LONG',
}

export interface SpendMetricsResponse {
  metric: string
  aggregate: SpendMetricsAggregates
  period: SpendMetricsPeriods
  type: SpendMetricsTypes
  dataSets: number[]
  series: MetricsSeries[]
}

export class SpendMetricsModel {
  public metric: string
  public aggregate: SpendMetricsAggregates
  public period: SpendMetricsPeriods
  public type: SpendMetricsTypes
  public dataSets: number[]
  public series: MetricsSeries[]

  public constructor(data: SpendMetricsResponse) {
    this.metric = data.metric
    this.aggregate = data.aggregate
    this.period = data.period
    this.type = data.type
    this.dataSets = data.dataSets
    this.series = data.series
  }
}
